import {
	Controller,
	ControllerRenderProps,
	FieldValues,
	useForm,
} from 'react-hook-form';
import React, { Fragment, useEffect, useState } from 'react';
import { getLast4Number, isDate } from '../utils/stringUtils';
import {
	getMetersRefNumber,
	getMetersRefNumberFromRegister,
	getRegister,
	getRegisterType,
	isOkRegisterIndex,
	isRedRegisterIndex,
} from '../utils/meterRegister';
import { useCloseLetter, useUpdateLetter } from '../hooks/letters';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import { BusinessError } from '../enums/buisnessError';
import { CloseLetterReqDTO } from '../dtos/closeLetterReqDTO';
import EncodeIndexItem from './EncodeIndexItem';
import ErrorState from './ErrorState';
// import { ImageListType } from 'react-images-uploading';
// import MeterUploadPictures from './MeterUploadPictures';
import { RegisterResDTO } from '../dtos/registerResDTO';
import { RegisterType } from '../enums/registerType';
// import Textarea from './Textarea';
import { UpdateLetterReqDTO } from '../dtos/updateLetterReqDTO';
import { UpdateRegisterReqDTO } from '../dtos/updateRegisterReqDTO';
import { letterState } from '../atoms/letter';
import { registerState } from '../atoms/register';
import { useTranslation } from 'react-i18next';

// import { useUploadMeterPictures } from '../hooks/mro';

interface StepEncodeIndexProps {
	title: string;
	isActive?: boolean;
	goToStep?: (step: number) => void;
}
function StepEncodeIndex({ title, isActive, goToStep }: StepEncodeIndexProps) {
	const setIsOkRegister = useSetRecoilState(registerState);
	const [date, setDate] = useState<Date | string>(new Date());
	const [encodeRetries, setEncodeRetries] = useState(0);
	// const [elecMeterPictures, setElecMeterPictures] = useState<ImageListType[]>(
	// 	[]
	// );
	// const [gasMeterPictures, setGasMeterPictures] = useState<ImageListType[]>([]);
	// const [gasMeterNumber, setGasMeterNumber] = useState<string | undefined>();
	// const [elecMeterNumber, setElecMeterNumber] = useState<string | undefined>();
	// const [gasComment, setGasComment] = useState<string>();
	// const [elecComment, setElecComment] = useState<string>();
	// const [picturesFormData, setPicturesFormData] = useState<FormData>();
	const letter = useRecoilValue(letterState);
	const [updateLetter, setUpdateLetter] = useState<UpdateLetterReqDTO>();
	const [closeLetter, setCloseLetter] = useState<CloseLetterReqDTO>();
	const {
		isFetching,
		isError: isUpdateLetterError,
		refetch: refetchUpdateLetter,
		error: UpdateLetterError,
	} = useUpdateLetter(updateLetter, false);

	const {
		isFetching: isCloseLetterFetching,
		error: isCloseLetterError,
		refetch: refetchCloseLetter,
	} = useCloseLetter(closeLetter, false);

	// const {
	// 	isFetching: isFetchingPictures,
	// 	isError: isErrorPictures,
	// 	refetch: refetchPictures,
	// } = useUploadMeterPictures(letter?.referenceCode, picturesFormData);
	const { t } = useTranslation();
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm();

	useEffect(() => {
		if (isActive) {
			if (updateLetter && closeLetter) {
				refetchUpdateLetter().then((response) => {
					if (
						response.status === 'success' ||
						(response.error as any).response.data.errorCode ===
							BusinessError.REG_OUT_OF_RANGE
					) {
						refetchCloseLetter().then((response) => {
							if (response.status === 'success') {
								// if (
								// 	picturesFormData &&
								// 	picturesFormData.entries().next().value
								// ) {
								// 	refetchPictures().then((response) => {
								// 		if (response.status === 'success') {
								// 			goToStep!(3);
								// 		}
								// 	});
								// } else {
								goToStep!(3);
								// }
							}
						});
					}
				});
			} else if (updateLetter && !closeLetter) {
				refetchUpdateLetter().then((response) => {
					if (
						response.status === 'success' ||
						(response.error as any).response.data.errorCode ===
							BusinessError.REG_OUT_OF_RANGE
					) {
						// if (picturesFormData && picturesFormData.entries().next().value) {
						// 	refetchPictures().then((response) => {
						// 		if (response.status === 'success') {
						// 			goToStep!(3);
						// 		}
						// 	});
						// } else {
						goToStep!(3);
						// }
					}
				});
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [updateLetter, isActive]);

	const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (isDate(e.target.value)) {
			setDate(new Date(e.target.value));
		} else {
			setDate(e.target.value as string);
		}
		setEncodeRetries(0);
	};

	const onSubmit = (data: any) => {
		const registers: RegisterResDTO[] = [];
		letter?.meters.forEach((meter) => registers.push(...meter.registers));
		const updatedLetter: UpdateLetterReqDTO = {
			referenceCode: letter!.referenceCode,
			date: date as Date,
			registers: Object.keys(data).map<UpdateRegisterReqDTO>((registerId) => ({
				meterNumber: getMetersRefNumberFromRegister(registerId, letter)!,
				type: getRegister(registerId, letter)!.type,
				currentIndex: Number(data[registerId]),
			})),
		};
		const hasRedRegister = Object.keys(data).some((registerId) =>
			isRedRegisterIndex(
				getRegister(registerId, letter)!,
				Number(data[registerId])
			)
		);
		setIsOkRegister({ isOK: !hasRedRegister });

		// const formData = new FormData();
		// elecMeterPictures.forEach((img) => {
		// 	formData.append('electricity', (img as any).file as Blob);
		// });
		// gasMeterPictures.forEach((img) => {
		// 	formData.append('gas', (img as any).file as Blob);
		// });
		// if (gasMeterNumber) {
		// 	formData.append('gas_meter_number', gasMeterNumber);
		// }
		// if (gasComment) {
		// 	formData.append('gas_comment', gasComment);
		// }
		// if (elecMeterNumber) {
		// 	formData.append('electricity_meter_number', elecMeterNumber);
		// }
		// if (elecComment) {
		// 	formData.append('electricity_comment', elecComment);
		// }

		// setPicturesFormData(formData);
		if (!hasRedRegister) {
			setCloseLetter({
				referenceCode: letter!.referenceCode,
				status: 'CLOSED',
			});
		}
		setUpdateLetter(updatedLetter);
	};

	const getErrorMessage = (
		field: ControllerRenderProps<FieldValues, string>
	) => {
		if (errors[field.name]?.type === 'required') {
			return (
				<span data-test-id='index-input-error-required'>
					{t('encode-index.index.error.required')}
				</span>
			);
		} else if (errors[field.name]?.type === 'maxLength') {
			return (
				<span data-test-id='index-input-error-max-length'>
					{t('encode-index.index.error.max-length', { max: 6 })}
				</span>
			);
		} else if (errors[field.name]?.type === 'invalidRange') {
			return (
				<span data-test-id='index-input-error-invalid-range'>
					{t('encode-index.index.error.invalid-range')}
				</span>
			);
		}
	};
	const renderRegisters = (rules: { hasInvalidRangeRules: boolean }) => {
		const electRegisters: JSX.Element[] = [];
		const gasRegisters: JSX.Element[] = [];
		let gasMeterReferenceNumber = '';
		let electMeterReferenceNumber = '';
		letter?.meters.forEach((meter, index) => {
			meter.registers.forEach((reg) => {
				const item = (
					<Controller
						key={reg.type}
						render={({ field }) => (
							<EncodeIndexItem
								field={field}
								type={reg.type}
								previousIndex={reg.previousIndex}
								footer={
									errors[field.name] ? (
										<div className='encode-index__error'>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												fill='none'
												viewBox='0 0 24 24'
												strokeWidth='1.5'
												stroke='currentColor'
												className='icon me-2'
											>
												<path
													strokeLinecap='round'
													strokeLinejoin='round'
													d='M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z'
												/>
											</svg>
											{getErrorMessage(field)}
										</div>
									) : undefined
								}
							/>
						)}
						name={reg.id}
						control={control}
						rules={{
							required: true,
							maxLength: 6,
							validate: {
								invalidRange: (value) => {
									if (rules.hasInvalidRangeRules) {
										return isOkRegisterIndex(reg, value);
									}
									return true;
								},
							},
						}}
						defaultValue=''
					/>
				);
				if (getRegisterType(reg.type) === RegisterType.GAS) {
					gasMeterReferenceNumber = meter.meterNumber;
					gasRegisters.push(item);
				} else {
					electMeterReferenceNumber = meter.meterNumber;
					electRegisters.push(item);
				}
			});
		});
		return {
			gas: gasRegisters.length ? (
				<Fragment>
					{gasRegisters}
					{/* <div className='container encode-index__footer '>
						<div className='row'>
							<div className='col-12 col-md-6 col-xl-8 pt-4 pb-md-3'>
								<Textarea
									label='Comment'
									value={gasComment}
									name='gas-comment'
									maxLength={228}
									onChange={handleChangeGasComment}
								/>
							</div>
							<div className='col-12 col-md-6 col-xl-4 pt-2 pt-md-4 pb-4'>
								<MeterUploadPictures
									images={gasMeterPictures}
									containerEl='gaz-images-container'
									onImagesChange={(images) =>
										handleGasMeterPicturesChange(
											images,
											gasMeterReferenceNumber
										)
									}
								/>
							</div>
						</div>
						<div className='row gaz-images-container'></div>
					</div> */}
				</Fragment>
			) : null,
			elect: electRegisters.length ? (
				<Fragment>
					{electRegisters}
					{/* <div className='container encode-index__footer'>
						<div className='row'>
							<div className='col-12 col-md-6 col-xl-8 pt-4 pb-md-3'>
								<Textarea
									label='Comment'
									value={elecComment}
									name='elec-comment'
									maxLength={228}
									onChange={handleChangeElecComment}
								/>
							</div>
							<div className='col-12 col-md-6 col-xl-4 pt-2 pt-md-4 pb-4'>
								<MeterUploadPictures
									images={elecMeterPictures}
									containerEl='elec-images-container'
									onImagesChange={(images) =>
										handleElecMeterPicturesChange(
											images,
											electMeterReferenceNumber
										)
									}
								/>
							</div>
						</div>
						<div className='row elec-images-container'></div>
					</div> */}
				</Fragment>
			) : null,
		};
	};

	// const handleGasMeterPicturesChange = (
	// 	images: ImageListType[],
	// 	meterNumber: string
	// ) => {
	// 	setGasMeterPictures(images);
	// 	setGasMeterNumber(meterNumber);
	// };

	// const handleElecMeterPicturesChange = (
	// 	images: ImageListType[],
	// 	meterNumber: string
	// ) => {
	// 	setElecMeterPictures(images);
	// 	setElecMeterNumber(meterNumber);
	// };

	// const handleChangeGasComment = (event: ChangeEvent<HTMLTextAreaElement>) => {
	// 	setGasComment(event.target.value);
	// };

	// const handleChangeElecComment = (event: ChangeEvent<HTMLTextAreaElement>) => {
	// 	setElecComment(event.target.value);
	// };

	const handleClickSubmit = (
		event: React.MouseEvent<HTMLButtonElement, MouseEvent>
	) => {
		const hasRequireValueErrors =
			Object.keys(errors).findIndex(
				(key) => errors[key]?.type === 'required'
			) !== -1;
		if (encodeRetries <= 1 && !hasRequireValueErrors) {
			setEncodeRetries(encodeRetries + 1);
		}
	};

	const gazRegisterItems = renderRegisters({
		hasInvalidRangeRules: encodeRetries === 1,
	}).gas;

	const elecRegisterItems = renderRegisters({
		hasInvalidRangeRules: encodeRetries === 1,
	}).elect;

	return (
		<div className='container encode-index'>
			<div className='row'>
				<div className='col-lg-10 col-xxl-8 offset-lg-1 offset-xxl-2'>
					<h2 className='visually-hidden'>{title}</h2>
					{isCloseLetterError ||
					(isUpdateLetterError &&
						(UpdateLetterError as any).response.data.errorCode !==
							BusinessError.REG_OUT_OF_RANGE) ? (
						<ErrorState />
					) : (
						<form onSubmit={handleSubmit(onSubmit)}>
							<div className='encode-index__list'>
								<div className='encode-index__list__form__header'>
									<a
										href={t('encode-index.how.to.read.question.url')}
										className='link'
										rel='noreferrer'
										target='_blank'
									>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											fill='none'
											viewBox='0 0 24 24'
											strokeWidth='2'
											stroke='currentColor'
											className='icon link__icon'
										>
											<path
												strokeLinecap='round'
												strokeLinejoin='round'
												d='m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z'
											/>
										</svg>

										<span className='link__text'>
											{t('encode-index.how.to.read.question')}
										</span>
									</a>
								</div>

								<div className='encode-index__list__header d-md-flex align-items-md-center justify-content-md-between'>
									<h4 className=' mb-md-0'>{`${letter?.firstName} ${letter?.lastName}`}</h4>
									<div className='calendar'>
										<div className='form-group'>
											<label htmlFor='dateText' className='visually-hidden'>
												Date
											</label>
											<input
												type='date'
												name='dateText'
												autoComplete='off'
												className='form-control form-control-date has-bg-icon'
												id='dateText'
												onKeyDown={() => false}
												onChange={handleDateChange}
												min={
													new Date(
														new Date().getTime() - 4 * 24 * 60 * 60 * 1000
													)
														.toISOString()
														.split('T')[0]
												}
												max={new Date().toISOString().split('T')[0]}
												value={
													isDate(date as string)
														? (date as Date)?.toISOString().split('T')[0]
														: ''
												}
											></input>
										</div>
									</div>
								</div>
								<div className='encode-index__list'>
									{elecRegisterItems && (
										<Fragment>
											<div className='encode-index__global-header '>
												<div className='encode-index__global-header__item encode-index__global-header__item__left'>
													<div className='w-50 text-start'>
														{t('register.type.electricity')}
													</div>
													<div className='w-50 text-start last'>
														{t('encode-index.only.last.number')}:{' '}
														{getLast4Number(
															getMetersRefNumber(letter)?.electricity
														)}
													</div>
												</div>
												<div className='encode-index__global-header__item encode-index__global-header__item__right d-none  d-xxl-flex'>
													<div className='w-50 text-start'>
														{t('encode-index.previous')}
													</div>
													<div className='w-50 text-end'>
														{t('encode-index.current')}
													</div>
												</div>
											</div>
											<div className='encode-index__list__group'>
												{elecRegisterItems}
											</div>
										</Fragment>
									)}
									{gazRegisterItems && (
										<Fragment>
											<div className='encode-index__global-header '>
												<div className='encode-index__global-header__item encode-index__global-header__item__left'>
													<div className='w-50 text-start'>
														{t('register.type.gas')}
													</div>
													<div className='w-50 text-start last'>
														{t('encode-index.only.last.number')}:{' '}
														{getLast4Number(getMetersRefNumber(letter)?.gas)}
													</div>
												</div>
												<div className='encode-index__global-header__item encode-index__global-header__item__right d-none  d-xxl-flex'>
													<div className='w-50 text-start'>
														{t('encode-index.previous')}
													</div>
													<div className='w-50 text-end'>
														{t('encode-index.current')}
													</div>
												</div>
											</div>
											<div className='encode-index__list__group mb-md-4'>
												{gazRegisterItems}
											</div>
										</Fragment>
									)}
								</div>
							</div>
							<div className='text-end d-flex justify-content-end'>
								<button
									data-test-id='index-btn-submit'
									className='btn btn--primary encode-index__send'
									type='submit'
									onClick={handleClickSubmit}
									disabled={isFetching || isCloseLetterFetching}
								>
									<span className='btn__text'>{t('common.send')}</span>
								</button>
							</div>
						</form>
					)}
				</div>
			</div>
		</div>
	);
}

export default StepEncodeIndex;
